import { Button } from "@mixitone/components";
import LockIcon from "@mixitone/icons/lock.svg";
import UnlockIcon from "@mixitone/icons/unlock.svg";
import type { TournamentCompetition } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import { roundRobinGroupsLocked, roundRobinHasGroups } from "components/Pages/Tournament/tournamentHelpers";
import TournamentStandingsController from "./TournamentStandingsController";

interface LockGroupsButtonProps {
  competition: TournamentCompetition;
  competitionId?: string;
  className?: string;
}

const LockGroupsButton = ({ competition, className }: LockGroupsButtonProps) => {
  const controller = TournamentStandingsController.use();
  const locked = roundRobinGroupsLocked(competition);
  const canLock = roundRobinHasGroups(competition);

  return (
    <Button
      kind="secondary"
      className={className}
      disabled={controller.state.loading || (!locked && !canLock)}
      title={
        locked
          ? "Unlock groups to allow automatic placement of new entries"
          : canLock
            ? "Lock groups so they stay as printed. You can still move people by hand."
            : "Set up groups before locking them"
      }
      onClick={() => controller.actionSetGroupsLocked(!locked)}
    >
      {locked ? (
        <LockIcon className="w-3.5 h-3.5 fill-current" />
      ) : (
        <UnlockIcon className="w-3.5 h-3.5 fill-current" />
      )}
      {locked ? "Unlock groups" : "Lock groups"}
    </Button>
  );
};

const LockGroupsButtonView = ApplicationView(LockGroupsButton);

export default LockGroupsButtonView;

export const ScopedLockGroupsButton = TournamentStandingsController.scope(LockGroupsButtonView);
